(() => {
  const HANDLE = 'fineline-clear-disposable-plastic-tumbler-500-case';
  const SIZE_ORDER = ['7 oz', '8 oz', '9 oz', '12 oz'];
  const CONFIG = window.DispoFinelineTumblerVariantRows || {};
  const addLabel = CONFIG.addLabel || 'Add';
  const unavailableLabel = CONFIG.unavailableLabel || 'Unavailable';
  let productPromise;

  const ensureStyles = () => {
    if (document.getElementById('fineline-tumbler-variant-row-styles')) return;

    const style = document.createElement('style');
    style.id = 'fineline-tumbler-variant-row-styles';
    style.textContent = `
      .fineline-tumbler-variants {
        position: relative;
        z-index: var(--layer-raised, 1);
        display: grid;
        width: 100%;
        gap: 6px;
        margin-block-start: 2px;
      }

      .fineline-tumbler-variant-row {
        display: grid;
        grid-template-columns: minmax(44px, 0.7fr) minmax(64px, 1fr) minmax(58px, auto);
        gap: 8px;
        align-items: center;
        width: 100%;
        min-width: 0;
        margin: 0;
        padding: 7px 8px;
        border: 1px solid rgb(var(--color-foreground-rgb) / 0.12);
        border-radius: 6px;
        background: rgb(var(--color-foreground-rgb) / 0.025);
      }

      .fineline-tumbler-variant-row__size,
      .fineline-tumbler-variant-row__price {
        min-width: 0;
        color: var(--color-foreground);
        font-size: 0.86rem;
        line-height: 1.15;
        overflow-wrap: anywhere;
      }

      .fineline-tumbler-variant-row__size {
        font-weight: 800;
      }

      .fineline-tumbler-variant-row__price {
        color: var(--dispo-price-color, #0f2e5a);
        font-weight: 900;
        text-align: right;
        white-space: nowrap;
      }

      .fineline-tumbler-variant-row__button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 0;
        min-height: 32px;
        padding: 5px 10px;
        border: 1px solid var(--dispo-cart-color, #2f8f22);
        border-radius: 4px;
        color: #ffffff;
        font: inherit;
        font-size: 0.82rem;
        font-weight: 900;
        line-height: 1;
        text-decoration: none;
        background: var(--dispo-cart-color, #2f8f22);
        cursor: pointer;
      }

      .fineline-tumbler-variant-row__button:hover,
      .fineline-tumbler-variant-row__button:focus-visible {
        border-color: var(--dispo-cart-hover-color, #246f1a);
        background: var(--dispo-cart-hover-color, #246f1a);
      }

      .fineline-tumbler-variant-row__button:disabled {
        border-color: rgb(var(--color-foreground-rgb) / 0.18);
        color: rgb(var(--color-foreground-rgb) / 0.54);
        background: rgb(var(--color-foreground-rgb) / 0.08);
        cursor: not-allowed;
      }

      @media screen and (max-width: 749px) {
        .fineline-tumbler-variants {
          gap: 5px;
        }

        .fineline-tumbler-variant-row {
          grid-template-columns: minmax(40px, 0.8fr) minmax(58px, auto) minmax(54px, auto);
          gap: 6px;
          padding: 6px;
        }

        .fineline-tumbler-variant-row__size,
        .fineline-tumbler-variant-row__price {
          font-size: 0.78rem;
        }

        .fineline-tumbler-variant-row__button {
          min-height: 30px;
          padding-inline: 8px;
          font-size: 0.76rem;
        }
      }
    `;

    document.head.append(style);
  };

  const formatMoney = (cents) => {
    const amount = Number(cents || 0) / 100;
    const currency = window.Shopify?.currency?.active || 'USD';

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency,
      }).format(amount);
    } catch (error) {
      return `$${amount.toFixed(2)}`;
    }
  };

  const getProduct = () => {
    if (!productPromise) {
      const root = window.Shopify?.routes?.root || '/';
      productPromise = fetch(`${root}products/${HANDLE}.js`, { credentials: 'same-origin' }).then((response) => {
        if (!response.ok) throw new Error(`Unable to load ${HANDLE}`);
        return response.json();
      });
    }

    return productPromise;
  };

  const findVariant = (product, sizeLabel) => {
    const normalizedSize = sizeLabel.toLowerCase();
    return product.variants.find((variant) => {
      const title = String(variant.title || '').toLowerCase();
      const option1 = String(variant.option1 || '').toLowerCase();
      return title === normalizedSize || option1 === normalizedSize;
    });
  };

  const buildRows = (product) => {
    const variants = SIZE_ORDER.map((sizeLabel) => findVariant(product, sizeLabel)).filter(Boolean);
    if (variants.length === 0) return null;

    ensureStyles();

    const wrapper = document.createElement('div');
    wrapper.className = 'fineline-tumbler-variants fineline-tumbler-variants--collection';
    wrapper.setAttribute('aria-label', product.title || 'Fineline tumbler sizes');

    variants.forEach((variant) => {
      const row = document.createElement('form');
      row.className = 'fineline-tumbler-variant-row';
      row.method = 'post';
      row.action = '/cart/add';
      row.addEventListener('click', (event) => event.stopPropagation());

      const variantInput = document.createElement('input');
      variantInput.type = 'hidden';
      variantInput.name = 'id';
      variantInput.value = String(variant.id);

      const quantityInput = document.createElement('input');
      quantityInput.type = 'hidden';
      quantityInput.name = 'quantity';
      quantityInput.value = '1';

      const size = document.createElement('span');
      size.className = 'fineline-tumbler-variant-row__size';
      size.textContent = variant.title;

      const price = document.createElement('span');
      price.className = 'fineline-tumbler-variant-row__price';
      price.textContent = formatMoney(variant.price);

      const button = document.createElement('button');
      button.type = 'submit';
      button.className = 'fineline-tumbler-variant-row__button';
      button.textContent = variant.available ? addLabel : unavailableLabel;
      button.disabled = !variant.available;
      button.addEventListener('click', (event) => event.stopPropagation());

      row.append(variantInput, quantityInput, size, price, button);
      wrapper.append(row);
    });

    return wrapper;
  };

  const upgradeCard = (card, product) => {
    if (card.dataset.finelineTumblerVariantRows === 'true') return;
    if (card.querySelector('.fineline-tumbler-variants')) return;

    const rows = buildRows(product);
    if (!rows) return;

    const oldPrice = card.querySelector('.collection-showcase-card__price-row');
    const oldForm = card.querySelector('.collection-showcase-card__form');
    const title = card.querySelector('.collection-showcase-card__title');

    if (oldPrice) {
      oldPrice.hidden = true;
      oldPrice.dataset.finelineReplaced = 'true';
    }

    if (oldForm) {
      oldForm.hidden = true;
      oldForm.dataset.finelineReplaced = 'true';
    }

    if (oldPrice) {
      oldPrice.insertAdjacentElement('afterend', rows);
    } else if (title) {
      title.insertAdjacentElement('afterend', rows);
    } else {
      card.append(rows);
    }

    card.dataset.finelineTumblerVariantRows = 'true';
  };

  const upgradeCards = async () => {
    const links = Array.from(document.querySelectorAll(`a[href*="/products/${HANDLE}"]`));
    const cards = [...new Set(links.map((link) => link.closest('.collection-showcase-card, product-card')).filter(Boolean))];
    if (cards.length === 0) return;

    try {
      const product = await getProduct();
      cards.forEach((card) => upgradeCard(card, product));
    } catch (error) {
      console.warn('[Dispo Trade] Fineline tumbler variant rows were not loaded.', error);
    }
  };

  const scheduleUpgrade = () => window.requestAnimationFrame(() => upgradeCards());

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleUpgrade, { once: true });
  } else {
    scheduleUpgrade();
  }

  const mainContent = document.getElementById('MainContent');
  if (mainContent) {
    const observer = new MutationObserver(scheduleUpgrade);
    observer.observe(mainContent, { childList: true, subtree: true });
  }
})();
